
<template>
    <!-- 便民查询记录表 -->
    <div class="buttonlist">
      <div class="buttonlist-m">
        <el-form
          :inline="true"
          :model="filteForm"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item>
            <el-button type="warning" icon="el-icon-back" plain @click="goBack">返回</el-button>
          </el-form-item>
          <el-form-item label="项目标题">
            <el-input v-model.trim="filteForm.name" auto-complete="off" maxlength="25" class="width80"></el-input>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="filteForm.startTime"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd 00:00:00"
              style="width: 160px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker
              v-model="filteForm.endTime"
              type="date"
              placeholder="截止日期"
              value-format="yyyy-MM-dd 23:59:59"
              style="width: 160px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
            <el-button type="success" icon="el-icon-download" plain @click="exportRecord">导出</el-button>
            <el-button v-if="showImportBtn" type="danger" icon="el-icon-upload2" plain @click="openImportDialog">导入</el-button>
          </el-form-item>
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
          <el-table
            :data="tableData"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column prop="user" label="查询人" align="center"></el-table-column>
            <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
            <el-table-column prop="idCard" label="身份证号" align="center"></el-table-column>
            <el-table-column prop="address" label="家庭住址" align="center"></el-table-column>
            <el-table-column prop="name" label="查询内容" align="center"></el-table-column>
            <el-table-column prop="creator" label="创建人" align="center"></el-table-column>
            <el-table-column prop="createdTime" label="创建时间" align="center" width="160"></el-table-column>
          </el-table>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>
      </div>

      <!-- 导入对话框 -->
      <el-dialog title="导入便民查询记录" :visible.sync="importDialogVisible" width="480px" @close="resetImportDialog">
        <div style="margin-bottom: 14px; padding: 10px 12px; background: #f4f4f5; border-radius: 4px; font-size: 13px; line-height: 1.8; color: #606266;">
          <div>📋 请先 <b>导出数据</b> 获取模板，按模板格式填写后导入。</div>
          <div><span style="color: #409EFF;">● ID 列有值</span> → 同组记录则<b>更新</b>，非本组则跳过</div>
          <div><span style="color: #67C23A;">● ID 列无值</span> → <b>新增</b>记录</div>
        </div>
        <el-upload
          ref="importUpload"
          drag
          :action="''"
          :auto-upload="false"
          :limit="1"
          accept=".xls,.xlsx"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :file-list="importFileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击选择</em></div>
          <div slot="tip" class="el-upload__tip">只能上传 xls / xlsx 文件</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importDialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="importLoading" :disabled="!importFile" @click="submitImport">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus";
  import { baseURL } from '@/utils/request.js';
  export default {
    data() {
      return {
        pageNum: 1,
        pageSize: 10,
        totalDataNumber: 0,
        loading: true,
        filteForm: {
          name: undefined,
          startTime: undefined,
          endTime: undefined
        },
        tableData: [],
        showImportBtn: false,
        searchClickCount: 0,
        searchClickTimer: null,
        importDialogVisible: false,
        importLoading: false,
        importFileList: [],
        importFile: null,
      };
    },
    methods: {
      goBack() {
        bus.$emit('close_current_tags');
      },
      onSubmit() {
        this.searchClickCount++;
        if (this.searchClickTimer) {
          clearTimeout(this.searchClickTimer);
        }
        this.searchClickTimer = setTimeout(() => {
          this.searchClickCount = 0;
        }, 2000);
        if (this.searchClickCount >= 5) {
          this.showImportBtn = !this.showImportBtn;
          this.searchClickCount = 0;
          this.$message.info(this.showImportBtn ? '导入按钮已显示' : '导入按钮已隐藏');
        }
        this.pageNum = 1;
        this.getTableData();
      },
      buildParams() {
        return {
          groupId: this.groupId,
          name: this.filteForm.name || undefined,
          startTime: this.filteForm.startTime || undefined,
          endTime: this.filteForm.endTime || undefined,
        };
      },
      tableRowStyle({ row, rowIndex }) {
        return rowIndex % 2 === 0 ? "background-color: #ffffff" : "background-color: #e4f5f8";
      },
      tableHeaderColor({ rowIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight:600;text-align:center;font-size:16px;background-color:#d4f5fa;";
        }
      },
      getTableData() {
        let params = Object.assign({}, this.buildParams(), {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        });
        this.loading = true;
        this.$postJson('omc/convenientSearch/showRecord', params).then(res => {
          if (res.code == 200) {
            this.totalDataNumber = Number(res.result.total);
            this.tableData = res.result.list;
          }
          this.loading = false;
        });
      },
      exportRecord() {
        const params = this.buildParams();
        const groupId = this.groupId || '';
        let url = `omc/api/downConvenientSearchRecord?groupId=${groupId}`;
        if (params.name) url += `&name=${encodeURIComponent(params.name)}`;
        if (params.startTime) url += `&startTime=${encodeURIComponent(params.startTime)}`;
        if (params.endTime) url += `&endTime=${encodeURIComponent(params.endTime)}`;
        window.location.href = baseURL + url;
      },
      openImportDialog() {
        this.importDialogVisible = true;
        this.$nextTick(() => {
          if (this.$refs.importUpload) {
            this.$refs.importUpload.clearFiles();
          }
        });
        this.importFileList = [];
        this.importFile = null;
      },
      resetImportDialog() {
        this.importFileList = [];
        this.importFile = null;
        this.importLoading = false;
        if (this.$refs.importUpload) {
          this.$refs.importUpload.clearFiles();
        }
      },
      handleFileChange(file) {
        this.importFile = file.raw;
      },
      handleFileRemove() {
        this.importFile = null;
      },
      submitImport() {
        if (!this.importFile) {
          this.$message.warning('请先选择要导入的文件');
          return;
        }
        this.importLoading = true;
        let formData = new FormData();
        formData.append('file', this.importFile);
        this.$postFormData('omc/convenientSearch/importRecord', formData).then(res => {
          this.importLoading = false;
          if (res.code == 200) {
            this.$message.success(res.message || '导入成功');
            this.importDialogVisible = false;
            this.getTableData();
          } else {
            this.$message.error(res.message || '导入失败');
          }
        }).catch(() => {
          this.importLoading = false;
          this.$message.error('导入请求失败');
        });
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getTableData();
      },
    },
    mounted() {
      this.getTableData();
    },
    created() {
      this.groupId = sessionStorage.getItem("groupId");
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
    .buttonlist-m {
      padding: 10px 0 0 5px;
    }
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  .width80 {
    width: 200px;
  }
  </style>
